import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from './icons/Icons';
export const Hero = () => {
  return <section id="inicio" className="relative bg-brand-ivory" data-id="element-205">
      {/* MOBILE: banner with bottom overlay headline + content continuing below */}
      <div className="md:hidden pt-28" data-id="element-206">
        <div className="relative w-full bg-brand-ivory" data-id="element-207">
          <img src="https://cdn.magicpatterns.com/uploads/vaS6G3xZ9JnYL1ug94aXzV/maria_fernanda.png" alt="Skin Glow Studio 22 Banner" className="w-full h-auto block" data-id="element-208" />
          {/* Soft fade at bottom of banner for headline readability */}
          <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-brand-ivory via-brand-ivory/85 to-transparent pointer-events-none" data-id="element-209"></div>

          {/* Headline overlaid on bottom of banner */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="absolute left-0 right-0 bottom-3 px-6 z-10" data-id="element-210">
            <h1 className="sm:text-4xl font-serif text-brand-charcoal mb-2 max-w-[78%] text-[19px]" data-id="element-211">
              Tu piel ya sabe lo que necesita.
            </h1>
            <p className="sm:text-lg text-brand-charcoal/80 font-serif italic max-w-[78%] text-[18px]" data-id="element-212">
              Solo estaba esperando las manos correctas.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="px-6 pt-6 pb-4" data-id="element-213">
          <div className="flex flex-col items-center text-center space-y-3 mb-8" data-id="element-214">
            <div className="h-px w-16 bg-brand-gold" data-id="element-215"></div>
            <p className="text-xs tracking-[0.2em] font-medium text-brand-bronze uppercase" data-id="element-216">
              Skin Glow Studio 22 — Spa &amp; Beauty
            </p>
            <p className="text-xs text-brand-charcoal/70 tracking-widest" data-id="element-217">
              ✦ Esthetician · Medical Assistant ✦
            </p>
            <p className="text-sm text-brand-charcoal/70 flex items-center gap-2" data-id="element-218">
              <span className="text-brand-gold" data-id="element-219">
                <MapPinIcon size={14} data-id="element-220" />
              </span>
              Philadelphia, PA
            </p>
          </div>

          <div className="flex flex-col gap-3" data-id="element-221">
            <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="text-center px-8 py-4 bg-brand-gold text-white text-sm font-medium rounded-full hover:bg-brand-bronze transition-all shadow-lg" data-id="element-222">
              Agenda tu cita
            </a>
            <a href="#servicios" className="text-center px-8 py-4 border border-brand-gold text-brand-charcoal text-sm font-medium rounded-full hover:bg-brand-gold/10 transition-colors" data-id="element-223">
              Ver servicios
            </a>
          </div>
        </motion.div>
      </div>

      {/* DESKTOP: text overlay positioned in bottom-left empty area of banner */}
      <div className="hidden md:block relative pt-28" data-id="element-224">
        <div className="relative w-full" data-id="element-225">
          <img src="https://cdn.magicpatterns.com/uploads/vaS6G3xZ9JnYL1ug94aXzV/maria_fernanda.png" alt="Skin Glow Studio 22 Banner" className="w-full h-auto block" data-id="element-226" />

          {/* Text overlay — bottom-left area, below the banner's SG logo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="absolute left-[5%] bottom-[2%] z-10 max-w-[46%] lg:max-w-[44%]" data-id="element-227">
            <h1 className="lg:text-5xl xl:text-6xl font-serif text-brand-charcoal mb-4 lg:mb-5 text-[44px]" data-id="element-228">
              Tu piel ya sabe lo que necesita.
            </h1>
            <p className="text-brand-charcoal/80 font-serif italic mb-6 lg:mb-7 text-[28px]" data-id="element-229">
              Solo estaba esperando las manos correctas.
            </p>

            <div className="flex flex-col items-start space-y-2 mb-6 lg:mb-7" data-id="element-230">
              <div className="h-px w-12 bg-brand-gold" data-id="element-231"></div>
              <p className="text-xs lg:text-sm tracking-[0.2em] font-semibold text-brand-charcoal uppercase" data-id="element-232">
                Skin Glow Studio 22 — Spa &amp; Beauty
              </p>
              <p className="text-xs lg:text-sm text-brand-charcoal/70 tracking-widest" data-id="element-233">
                ✦ Esthetician · Medical Assistant ✦
              </p>
              <p className="text-sm text-brand-charcoal/70 flex items-center gap-2" data-id="element-234">
                <span className="text-brand-gold" data-id="element-235">
                  <MapPinIcon size={14} data-id="element-236" />
                </span>
                Philadelphia, PA
              </p>
            </div>

            <div className="flex flex-row items-center gap-3 lg:gap-4" data-id="element-237">
              <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="text-center px-6 lg:px-8 py-3 lg:py-3.5 bg-brand-gold text-white text-sm lg:text-base font-medium rounded-full hover:bg-brand-bronze transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-238">
                Agenda tu cita
              </a>
              <a href="#servicios" className="text-center px-6 lg:px-8 py-3 lg:py-3.5 border border-brand-gold text-brand-charcoal text-sm lg:text-base font-medium rounded-full hover:bg-brand-gold/10 transition-colors bg-brand-blush/50 backdrop-blur-sm" data-id="element-239">
                Ver servicios
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};